"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var messaging_send_request_1 = require("./messaging-send-request");
/**
 * Serialiser for {@link MessagingSendRequest}
 */
var MessagingSendRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MessagingSendRequestSerialiserClass, _super);
    function MessagingSendRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link MessagingSendRequest} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link MessagingSendRequest} that was read
     */
    MessagingSendRequestSerialiserClass.prototype.read = function (bis) {
        var path = Codec.readString(bis);
        var dataType = Codec.readString(bis);
        var request = Codec.readBytes(bis);
        return new messaging_send_request_1.MessagingSendRequest(path, dataType, request);
    };
    /**
     * Write a {@link MessagingSendRequest} to the stream
     *
     * @param bos    the output stream
     * @param value  the {@link MessagingSendRequest} to be written
     */
    MessagingSendRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeString(bos, value.path);
        Codec.writeString(bos, value.dataType);
        Codec.writeBytes(bos, value.request);
    };
    return MessagingSendRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessagingSendRequestSerialiserClass = MessagingSendRequestSerialiserClass;
/**
 * The {@link MessagingSendRequestSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessagingSendRequestSerialiser = new MessagingSendRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-send-request-serialiser.js
// module id = 1204
// module chunks = 1